export { objectAssign };
import { assert } from './assert.js';
// Same as Object.assign() but:
//  - With type inference
//  - Preserves property descriptors, which we need for preserving the getters added by getPageContextUrlComputed()
function objectAssign(obj, objAddendum) {
    if (objAddendum) {
        assert(!('_isPageContextObject' in objAddendum));
        Object.defineProperties(obj, Object.getOwnPropertyDescriptors(objAddendum));
    }
}
